import { i18n, CurrentUser,utils } from "@common";

export const AuditLogsStatus = {
    failed: 0,
    successful: 1,
    Null: 2
};
export const AuditLogsStatusI18N = {
    [AuditLogsStatus.failed]: i18n.get('CIS_Admin_Common_Failed_Entry'),
    [AuditLogsStatus.successful]: i18n.get('CIS_Admin_Common_Successful_Entry'),
    [AuditLogsStatus.Null]: i18n.get('CIS_Admin_Common_Null_Entry'),
};
export const AuditLogsStatusOptions = [
    { name: AuditLogsStatusI18N[AuditLogsStatus.failed], value: AuditLogsStatus.failed },
    { name: AuditLogsStatusI18N[AuditLogsStatus.successful], value: AuditLogsStatus.successful },
    { name: AuditLogsStatusI18N[AuditLogsStatus.Null], value: AuditLogsStatus.Null },
];

export const AuditLogRoleType = {
    AvePointSupport: 'CISAdmin.Full',
    IHLHelpdeskEngineer: 'CISAdmin.HelpDesk',
    ReportAdmin: 'CISAdmin.Report',
    Applicant: 'Applicant',
    Student: 'Student',
    BlankRole: '',
};
export const AuditLogRoleTypeI18N = {
    [AuditLogRoleType.AvePointSupport]: i18n.get('CIS_Admin_Reporting_AuditLogs_RoleType_AvePointSupport_Entry'),
    [AuditLogRoleType.IHLHelpdeskEngineer]: i18n.get('CIS_Admin_Reporting_AuditLogs_RoleType_IHLHelpdeskEngineer_Entry'),
    [AuditLogRoleType.ReportAdmin]: i18n.get('CIS_Admin_Reporting_AuditLogs_RoleType_ReportAdmin_Entry'),
    [AuditLogRoleType.BlankRole]: i18n.get('CIS_Admin_Reporting_AuditLogs_RoleType_Blank_Entry'),
    [AuditLogRoleType.Applicant]: i18n.get('CIS_Admin_Reporting_AuditLogs_RoleType_Applicant_Entry'),
    [AuditLogRoleType.Student]: i18n.get('CIS_Admin_Reporting_AuditLogs_RoleType_Student_Entry'),
};
export const AuditLogRoleTypeOptions = utils.array.sort([
    { name: AuditLogRoleTypeI18N[AuditLogRoleType.AvePointSupport], value: AuditLogRoleType.AvePointSupport },
    { name: AuditLogRoleTypeI18N[AuditLogRoleType.IHLHelpdeskEngineer], value: AuditLogRoleType.IHLHelpdeskEngineer },
    { name: AuditLogRoleTypeI18N[AuditLogRoleType.ReportAdmin], value: AuditLogRoleType.ReportAdmin },
    { name: AuditLogRoleTypeI18N[AuditLogRoleType.BlankRole], value: AuditLogRoleType.BlankRole },
    { name: AuditLogRoleTypeI18N[AuditLogRoleType.Applicant], value: AuditLogRoleType.Applicant },
    { name: AuditLogRoleTypeI18N[AuditLogRoleType.Student], value: AuditLogRoleType.Student }
], true, 'name');

export const SignInLogsStatus = {
    failed: 0,
    successful: 1,
};
export const SignInLogsStatusI18N = {
    [SignInLogsStatus.failed]: i18n.get('CIS_Admin_Common_Failed_Entry'),
    [SignInLogsStatus.successful]: i18n.get('CIS_Admin_Common_Successful_Entry'),
};
export const SignInLogsStatusOptions = [
    { name: SignInLogsStatusI18N[SignInLogsStatus.failed], value: SignInLogsStatus.failed },
    { name: SignInLogsStatusI18N[SignInLogsStatus.successful], value: SignInLogsStatus.successful },
];

export const DateRangeFilter = {
    Last1month: 0,
    Last7days: 1,
    Last24hours: 2
};

export const StaffScheduleInterval = {
    Monthly: 0,
    Quarterly: 1,
    Annually: 2
};

export const StaffScheduleIntervalI18N = {
    [StaffScheduleInterval.Monthly]: i18n.get("CIS_Admin_Reporting_StaffAccessReview_Schedule_Monthly_Entry"),
    [StaffScheduleInterval.Quarterly]: i18n.get("CIS_Admin_Reporting_StaffAccessReview_Schedule_Quarterly_Entry"),
    [StaffScheduleInterval.Annually]: i18n.get("CIS_Admin_Reporting_StaffAccessReview_Schedule_Annually_Entry"),
};

export const StaffScheduleIntervalOptions = [
    { name: StaffScheduleIntervalI18N[StaffScheduleInterval.Monthly], value: StaffScheduleInterval.Monthly },
    { name: StaffScheduleIntervalI18N[StaffScheduleInterval.Quarterly], value: StaffScheduleInterval.Quarterly },
    { name: StaffScheduleIntervalI18N[StaffScheduleInterval.Annually], value: StaffScheduleInterval.Annually },
];


export const StaffPeriod = {
    LastSevenDays: 0,
    LastOneMonth: 1,
    LastYear: 2
};

export const StaffPeriodlI18N = {
    [StaffPeriod.LastSevenDays]: i18n.get("CIS_Admin_Reporting_StaffAccessReview_Filter_LastSevenDays_Entry"),
    [StaffPeriod.LastOneMonth]: i18n.get("CIS_Admin_Reporting_StaffAccessReview_Filter_LastOneMonth_Entry"),
    [StaffPeriod.LastYear]: i18n.get("CIS_Admin_Reporting_StaffAccessReview_Filter_LastYear_Entry"),
};

export const StaffPeriodlI18NOptions = [
    { name: StaffPeriodlI18N[StaffPeriod.LastSevenDays], value: StaffPeriod.LastSevenDays },
    { name: StaffPeriodlI18N[StaffPeriod.LastOneMonth], value: StaffPeriod.LastOneMonth },
    { name: StaffPeriodlI18N[StaffPeriod.LastYear], value: StaffPeriod.LastYear },
];


export const SuspiciousActivityLevel = {
    low: 1,
    medium: 2,
    high: 3,
};
export const SuspiciousActivityLevelI18N = {
    [SuspiciousActivityLevel.low]: i18n.get('CIS_Admin_Common_Low_Entry'),
    [SuspiciousActivityLevel.medium]: i18n.get('CIS_Admin_Common_Medium_Entry'),
    [SuspiciousActivityLevel.high]: i18n.get('CIS_Admin_Common_High_Entry'),
};
export const SuspiciousActivityLevelOptions = [
    { name: SuspiciousActivityLevelI18N[SuspiciousActivityLevel.low], value: SuspiciousActivityLevel.low },
    { name: SuspiciousActivityLevelI18N[SuspiciousActivityLevel.medium], value: SuspiciousActivityLevel.medium },
    { name: SuspiciousActivityLevelI18N[SuspiciousActivityLevel.high], value: SuspiciousActivityLevel.high },
];

export const AccountStatus = {
    Enabled: 0,
    Disabled: 1,
    Syncing: 2,
};
export const AccountStatuslI18N = {
    [AccountStatus.Enabled]: i18n.get('CIS_Admin_StudentManagement_Filter_Enabled_Entry'),
    [AccountStatus.Disabled]: i18n.get('CIS_Admin_StudentManagement_Filter_Disabled_Entry'),
    [AccountStatus.Syncing]: i18n.get('CIS_Admin_StudentManagement_Filter_Syncing_Entry'),

};
export const AccountStatusOptions = [
    { name: AccountStatuslI18N[AccountStatus.Enabled], value: AccountStatus.Enabled },
    { name: AccountStatuslI18N[AccountStatus.Disabled], value: AccountStatus.Disabled },
];

export const permissionStudentManagement = {
    get create() { return CurrentUser.permission.StudentManagement?.create; }, // create\new\copy\add version\import
    get edit() { return CurrentUser.permission.StudentManagement?.update; }, // edit
    get update() { return CurrentUser.permission.StudentManagement?.update; }, // deactivate\activate\publish\assign
    get delete() { return CurrentUser.permission.StudentManagement?.delete; }, // delete
    get read() { return CurrentUser.permission.StudentManagement?.read; }, // read
};

export const permissionReport = {
    get create() { return CurrentUser.permission.Report?.create; }, // create\new\copy\add version\import
    get edit() { return CurrentUser.permission.Report?.update; }, // edit
    get update() { return CurrentUser.permission.Report?.update; }, // deactivate\activate\publish\assign
    get delete() { return CurrentUser.permission.Report?.delete; }, // delete
    get read() { return CurrentUser.permission.Report?.read; }, // read

};

export const permissionEmailTemplate = {
    get create() { return CurrentUser.permission.EmailTemplate?.create; }, // create\new\copy\add version\import
    get edit() { return CurrentUser.permission.EmailTemplate?.update; }, // edit
    get update() { return CurrentUser.permission.EmailTemplate?.update; }, // deactivate\activate\publish\assign
    get delete() { return CurrentUser.permission.EmailTemplate?.delete; }, // delete
    get read() { return CurrentUser.permission.EmailTemplate?.read; }, // read

};

export const permissionApplicationUsage = {
    get create() { return CurrentUser.permission.ApplicationUsage?.create; }, // create\new\copy\add version\import
    get edit() { return CurrentUser.permission.ApplicationUsage?.update; }, // edit
    get update() { return CurrentUser.permission.ApplicationUsage?.update; }, // deactivate\activate\publish\assign
    get delete() { return CurrentUser.permission.ApplicationUsage?.delete; }, // delete
    get read() { return CurrentUser.permission.ApplicationUsage?.read; }, // read

};

export const permissionAuditLogs = {
    get create() { return CurrentUser.permission.AuditLogs?.create; }, // create\new\copy\add version\import
    get edit() { return CurrentUser.permission.AuditLogs?.update; }, // edit
    get update() { return CurrentUser.permission.AuditLogs?.update; }, // deactivate\activate\publish\assign
    get delete() { return CurrentUser.permission.AuditLogs?.delete; }, // delete
    get read() { return CurrentUser.permission.AuditLogs?.read; }, // read

};

export const permissionSignInLogs = {
    get create() { return CurrentUser.permission.SignInLogs?.create; }, // create\new\copy\add version\import
    get edit() { return CurrentUser.permission.SignInLogs?.update; }, // edit
    get update() { return CurrentUser.permission.SignInLogs?.update; }, // deactivate\activate\publish\assign
    get delete() { return CurrentUser.permission.SignInLogs?.delete; }, // delete
    get read() { return CurrentUser.permission.SignInLogs?.read; }, // read

};

export const permissionStaffAccessReview = {
    get create() { return CurrentUser.permission.StaffAccessReview?.create; }, // create\new\copy\add version\import
    get edit() { return CurrentUser.permission.StaffAccessReview?.update; }, // edit
    get update() { return CurrentUser.permission.StaffAccessReview?.update; }, // deactivate\activate\publish\assign
    get delete() { return CurrentUser.permission.StaffAccessReview?.delete; }, // delete
    get read() { return CurrentUser.permission.StaffAccessReview?.read; }, // read
};

export const permissionSuspiciousActivity = {
    get create() { return CurrentUser.permission.SuspiciousActivity?.create; }, // create\new\copy\add version\import
    get edit() { return CurrentUser.permission.SuspiciousActivity?.update; }, // edit
    get update() { return CurrentUser.permission.SuspiciousActivity?.update; }, // deactivate\activate\publish\assign
    get delete() { return CurrentUser.permission.SuspiciousActivity?.delete; }, // delete
    get read() { return CurrentUser.permission.SuspiciousActivity?.read; }, // read
};

export const permissionGroupManagement = {
    get create() { return CurrentUser.permission.GroupManagement?.create; }, // create\new\copy\add version\import
    get edit() { return CurrentUser.permission.GroupManagement?.update; }, // edit
    get update() { return CurrentUser.permission.GroupManagement?.update; }, // deactivate\activate\publish\assign
    get delete() { return CurrentUser.permission.GroupManagement?.delete; }, // delete
    get read() { return CurrentUser.permission.GroupManagement?.read; }, // read
};